import React, { useState } from "react";
import { SliderProps } from "../../interfaces/SliderData";
import { Slide } from "./Slide";

export function Slider({ slides, pr }: SliderProps) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    const prevSlide = () => setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));

    if (!slides || slides.length === 0) return null;

    return (
        // SOLUCIÓN: Eliminamos aspect-ratio e h-[30rem]. Dejamos que sea relativo y se adapte al hijo activo.
        <div className="relative w-full overflow-hidden md:overflow-visible group bg-white">
            {/* Iteramos sobre el array para crear los slides */}
            {slides.map((slideData, index) => {
                const isActive = index === currentIndex;
                return (
                    <div
                        key={index}
                        // SOLUCIÓN: Si está activo usa "relative block", si no, "absolute top-0 left-0 hidden"
                        // Esto hace que el Slider mida EXACTAMENTE lo mismo que mida el Slide de adentro.
                        className={`w-full transition-opacity duration-700 ease-in-out ${
                            isActive ? "relative block opacity-100 z-10" : "absolute top-0 left-0 opacity-0 z-0 pointer-events-none"
                        }`}
                    >
                        <Slide data={slideData} pr={pr} />
                    </div>
                );
            })}

            {/* CONTROLES (Flechas) */}
            {slides.length > 1 && (
                <>
                    <button
                        onClick={prevSlide}
                        className="absolute left-4 top-1/2 -translate-y-1/2 z-30 text-white bg-black/40 hover:bg-black/70 w-10 h-10 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity hidden md:flex cursor-pointer"
                        aria-label="Anterior"
                    >
                        &#10094;
                    </button>

                    <button
                        onClick={nextSlide}
                        className="absolute right-4 top-1/2 -translate-y-1/2 z-30 text-white bg-black/40 hover:bg-black/70 w-10 h-10 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity hidden md:flex cursor-pointer"
                        aria-label="Siguiente"
                    >
                        &#10095;
                    </button>
                </>
            )}
        </div>
    );
}